// extracted by mini-css-extract-plugin
module.exports = {"root":"📦JQUIListItem__root--35QCv","title":"📦JQUIListItem__title--3sgx0","active":"📦JQUIListItem__active--2LeTK"};